<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row class="justify-center">
          <v-card max-width="620" outlined>
            <v-card-title class="text-center">
              Sorry, but you do not have access to the Room Booking Panel.
            </v-card-title>
            <v-card-subtitle class="text-center">
              Please contact your administrator if you require access.
            </v-card-subtitle>
            <v-card-actions class="justify-center">
              <v-btn @click="signOut" outlined rounded>Logout</v-btn>
            </v-card-actions>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: 'NoAccess',
  methods: {
    ...mapActions('auth', {doSignOut: 'signOut'}),
    signOut() {
      this.doSignOut()
          .then(() => this.$nextTick(() => this.$router.push('/login')));
    }
  }
};
</script>

<style scoped>

</style>
